import { render, staticRenderFns } from "./FlycalRequests.vue?vue&type=template&id=68379552&"
import script from "./FlycalRequests.vue?vue&type=script&lang=js&"
export * from "./FlycalRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports